import AssessmentInvite from "pages/PanelPage/components/selectedAssessment/assessmentInvite/AssessmentInvite/AssessmentInvite";

export default AssessmentInvite;
